
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SettingsSidebarView from '@/app/views/settings/SettingsSidebarView.vue';
import PartnerSettingsSidebarView from '@/app/views/admin/settings/PartnerSettingsSidebarView.vue';
import { useAuthStore } from '@/app/store/authModule';

@Component({
  components: {
    SettingsSidebarView,
    PartnerSettingsSidebarView,
  },
})
export default class SideNavSettingsLink extends Vue {
  @Prop({ default: '/settings' }) basePath!: string;

  private settingsOpen: boolean = false;

  get authStore() {
    return useAuthStore();
  }

  get inSettings() {
    return this.$route.fullPath.includes('/settings');
  }

  get isAgent() {
    return this.authStore.isAgent;
  }

  @Watch('$route.fullPath', { immediate: true })
  onRouteChange() {
    this.settingsOpen = this.inSettings;
  }

  toggleSettings() {
    this.settingsOpen = !this.settingsOpen;
  }
}
